module.exports = __webpack_public_path__ + "static/6305-woodrose-40-08edb1e6c2a66dce703c24f18526abad.jpg";